import React from 'react';
import { Button } from '@fiverr-private/button';
import { Domingo } from '@fiverr-private/domingo';
import { I18n } from '@fiverr-private/i18n-react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container } from '@fiverr-private/layout_components';
import { ArrowRightIcon } from '@fiverr-private/icons';
import { ClientsRate } from '../../../shared/types';
import { sendBqEvent } from '../../../events/bigQuery';

import { buttonClass } from './ViewMoreLink.ve.css';

interface ViewMoreLinkProps {
    category: ClientsRate['category'];
    slug?: string;
}

export const ViewMoreLink = ({ category, slug }: ViewMoreLinkProps) => {
    const { url } = getContext();

    const href = Domingo(url)
        .pro()
        .path('search_gigs', undefined, {
            query: { query: category, source: 'skill_pages' },
        }).url;

    const onClick = () => {
        sendBqEvent('user_action', {
            type: 'seo_pro_listing_click',
            actionType: 'click',
            element: {
                name: slug,
                type: 'button',
                text: 'view more freelancers',
            },
        });
    };

    return (
        <Container
            display="flex"
            justifyContent="center"
            padding="0"
            paddingBottom="0"
            marginTop={{ default: '8', lg: '12' }}
        >
            <Button onClick={onClick} href={href} rel="nofollow" size="md" intent="secondary" className={buttonClass}>
                <I18n k="skill_page_perseus.view_more_cta" />
                <ArrowRightIcon />
            </Button>
        </Container>
    );
};
